// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-gauge-progress';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 3.312a5.623 5.623 0 0 1 5.616 5.616A5.623 5.623 0 0 1 9 14.544a5.623 5.623 0 0 1-5.616-5.616m13.824 1.944c-.144.72-.432 1.44-.792 2.16m-1.584 2.016c-.576.504-1.152 1.008-1.872 1.368M9.72.576c.792.072 1.512.216 2.232.504m2.232 1.224a6.954 6.954 0 0 1 1.584 1.656m1.152 2.16c.288.72.432 1.44.432 2.232' />
    <path d='M10.656 17.208c-4.536.936-9-2.016-9.936-6.552-.936-4.536 2.016-9 6.624-9.936' />
  </g>
);

export const viewBox = '0 0 18 18';
